import {
  Box,
  Icon,
  TextAction,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

export const SecuritySettingsCard = ({
  titleId,
  linkUrl,
  icon,
}: {
  titleId: string;
  linkUrl: string;
  icon: string;
}) => {
  const { formatMessage } = useIntl();
  const title = formatMessage({ id: titleId as never });

  return (
    <TextAction
      href={linkUrl}
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '$oneAndHalf',
        textAlign: 'left',
        fontSize: '$bodyTwo',
        fontWeight: 'normal',
        color: '$onSurfaceTextPrimary',
        backgroundColor: '$surfaceBackgroundPrimary',
        border: '1px solid $onSurfaceBorderSubdued',
        borderRadius: '$medium',
        marginBlockEnd: '$oneAndHalf',
        width: '100%',
        '&:hover': {
          textDecoration: 'none',
          backgroundColor: '$surfaceBackgroundSecondary',
        },
      }}
    >
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          typography: '$subtitleOne',
        }}
      >
        <Icon
          icon={icon}
          size="$two"
          css={{ marginY: 'auto', marginInlineEnd: '$one' }}
        />

        {title}
      </Box>
      <VisuallyHidden data-testid="new-tab-msg">
        {formatMessage({ id: 'STR_OPENS_IN_A_NEW_TAB' })}
      </VisuallyHidden>
    </TextAction>
  );
};
